import axios from "../../config/axiosConfig";

export default class OffreDemandeService {
  addOffreDemande = async (data) => {
    try {
      const response = await axios.post("/demande-pack", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la création de la candidatures : " + error.message
      );
    }
  };
  getAllOffreDemande = async () => {
    try {
      const response = axios.get("/demande-pack");
      return response;
    } catch (error) {
      throw new Error("Erreur  : " + error.message);
    }
  };
}
